import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {InformationService} from "../../services/information.service";
import {MatTreeFlatDataSource, MatTreeFlattener} from "@angular/material/tree";
import {FlatTreeControl} from "@angular/cdk/tree";
import {environment} from "../../../environments/environment";
import {Router} from "@angular/router";
import {  SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less']
})
export class FooterComponent implements OnInit, OnDestroy {

  addressLink: SafeHtml;
  telegram: SafeHtml;
  instagram: SafeHtml;
  email: string;
  emailLink: string;
  legalInfo: string;

  shopInfo: SafeHtml;
  ownerinfo: SafeHtml;
  reclamationInfo: string;
  reclamationLinc: string;
  showReclamation: boolean = false;

  private destroySubject: Subject<void> = new Subject();

  constructor(
    private router: Router,
    private informationService: InformationService,
  ) {
      this.showReclamation = environment.showReclamation;
      this.addressLink = environment.shopAddress.link;

   }

  ngOnInit(): void {

    this.informationService.getFrontParams().pipe(
      takeUntil(this.destroySubject),
    )
      .subscribe(
        (res: any) => {
          let shopInfoHtml = res.results.find ((value:any) =>  value.name == 'shopinfo')?.value;
          this.shopInfo =  this.informationService.getSanitizeString(shopInfoHtml);

          let ownerinfoHtml =  res.results.find ((value:any) =>  value.name == 'ownerinfo')?.value;
          this.ownerinfo =  this.informationService.getSanitizeString(ownerinfoHtml);

         this.email =  res.results.find ((value:any) =>  value.name == 'email')?.value;
         this.emailLink = "mailto:" + this.email

         this.telegram = res.results.find ((value:any) =>  value.name == 'telegram')?.value;

         this.instagram = res.results.find ((value:any) =>  value.name == 'instagram')?.value;

        })
  }


  navigate($event: any) {
    this.router.navigate([$event], {})

  }


  ngOnDestroy() {
    this.destroySubject.next();
  }


}
